<template>
  <v-container id="cardcontainer-main" fluid pa-0 ma-0>
    <v-layout wrap row>
      <v-flex xs12 md4 pt-3 mb-4>
        <v-btn
          class="ma-0"
          id="cardcontainer-create-btn"
          color="success"
          :to="newItemPath"
        >Create A New {{itemLabel}}</v-btn>
      </v-flex>

      <v-flex xs12 md8>
        <v-container pa-0 ma-0>
          <v-layout wrap row>
            <v-flex
              xs12
              sm6
              pt-1
              :class="{'pr-0 ': $vuetify.breakpoint.xsAndDown, 'pr-2': $vuetify.breakpoint.smAndUp}"
            >
              <v-text-field
                box
                class="cardcontainer-search-text pa-0 ma-0 body-1"
                v-model="searchTerm"
                label="Search"
                clearable
                color="secondary"
                clear-icon="cancel"
              >
                <template slot="append">
                  <v-icon>search</v-icon>
                </template>
              </v-text-field>
            </v-flex>
            <v-flex
              xs12
              sm6
              pt-1
              :class="{'pl-0': $vuetify.breakpoint.xsAndDown, 'pl-2': $vuetify.breakpoint.smAndUp}"
            >
              <v-select
                box
                style="border-bottom:0 !important; "
                class="cardcontainer-order-select pa-0 ma-0 body-1"
                :items="sortableBy"
                v-model="orderSelection"
                label="Order by"
                clearable
                color="secondary"
                clear-icon="cancel"
                append-icon="keyboard_arrow_down"
              ></v-select>
            </v-flex>

            <!--
          <v-btn id="cardcontainer-toggle-descending-btn" small ripple icon v-if="this.ascendingOrder" @click="toggleAscending"><v-icon>arrow_upward</v-icon></v-btn>
          <v-btn id="cardcontainer-toggle-ascending-btn" small ripple icon v-if="!this.ascendingOrder" @click="toggleAscending"><v-icon>arrow_downward</v-icon></v-btn>
            -->
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>

    <v-layout fluid row>
      <v-flex xs12>
        <Loading :isLoading="isLoading">
          <v-container fluid pa-0 >
            <v-layout wrap id="cardcontainer-cards" class="card-margin-fix">
              <v-flex
              xs12 sm6 lg4
              xl3 px-2
              mb-3 v-for="(item, i) in itemList" :key="i">
                <component :is="itemType" :cardContent="item"></component>
              </v-flex>
            </v-layout>
          </v-container>
        </Loading>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import TeamCard from "@/components/teams/TeamCard.vue"
import UserCard from "@/components/Users/UserCard.vue"
import PageTitle from "@/components/PageTitle.vue"
import Loading from "@/components/shared/Loading.vue"

export default {
  name: "cards",
  components: { TeamCard, UserCard, Loading, PageTitle },
  props: [
    "itemType",
    "itemLabel",
    "newItemPath",
    "title",
    "itemList",
    "sortableBy",
    "searchableBy",
    "isLoading"
  ],
  data: () => ({
    searchTerm: "",
    orderSelection: "",
    ascendingOrder: true
  }),
  watch: {
    orderSelection: function() {
      this.$store.dispatch("sortArray", {
        array: this.itemList,
        prop: this.orderSelection,
        type: this.itemType,
        isAscending: this.ascendingOrder
      })
    },
    searchTerm: function() {
      this.$store.dispatch("searchArray", {
        array: this.itemList,
        term: this.searchTerm,
        searchableBy: this.searchableBy,
        type: this.itemType
      })
    }
  },
  methods: {
    toggleAscending() {
      this.ascendingOrder = !this.ascendingOrder
      this.$store.dispatch("sortArray", {
        array: this.itemList,
        prop: this.orderSelection,
        type: this.itemType,
        isAscending: this.ascendingOrder
      })
    }
  },
  computed: {}
}
</script>
